import { render, staticRenderFns } from "./LimitedStateUpgradeModal.vue?vue&type=template&id=0e3a94c7"
import script from "./LimitedStateUpgradeModal.vue?vue&type=script&lang=js"
export * from "./LimitedStateUpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports